import { apiTimeExceededErrorMessages, parkingQueryKeys } from "../../constants";
import { fetchData } from "services/api";
import { useQuery } from "@tanstack/react-query";
import { PriceCalculationMulti } from "types/priceCalculation.type";

interface IUseGetParkingPriceByMinutesParams {
    licensePlate: string;
    featureType: string;
    featureCode: string;
    requestTime: string;
}

export const useGetParkingPriceByMinutes = (params: IUseGetParkingPriceByMinutesParams) => {
    const { licensePlate, featureType, featureCode, requestTime } = params;
    
    return useQuery({
        queryKey: parkingQueryKeys.priceByMinutes.get(licensePlate, featureType, featureCode, requestTime),
        staleTime: 0,
        gcTime: 0,
        enabled: !!licensePlate && licensePlate.length > 0 && !!featureType && !!featureCode,
        queryFn: async (): Promise<PriceCalculationMulti> => {
            const response = await fetchData("Tickets/streetParking/calculateprice/multi", "POST", "body", {
                licensePlate,
                sectionCode: featureType === "pz" ? featureCode : null,
                parkMachineCode: featureType === "pm" || featureType === "ib" ? featureCode : null,
                minutesStep: 1,
                maxSteps: 1440,
            });
            return response;
        },
        retry: (failureCount: number, error: Error): boolean => {
            if (apiTimeExceededErrorMessages.includes(error.message) || error.message.startsWith("Api Error: No valid parking duration found")) {
                return false;
            }
            return failureCount < 3;
        },
    });
};
